import styled, { css } from "styled-components";

interface PropsLightBox {
  isOpened: boolean;
}

export const LightBox = styled.div<PropsLightBox>`
  width: 100vw;
  height: 100vh;
  position: fixed;
  visibility: hidden;
  opacity: 0;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  ${(props) => props.theme.motion};

  ${(props) =>
    props.isOpened &&
    css`
      visibility: visible;
      opacity: 1;
    `}
  @media(min-width: 768px) {
    ${(props) => props.theme.lightbox}
  }
`;

interface PropsModal {
  size: string;
  isOpened: boolean;
}

export const Modal = styled.div<PropsModal>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  ${(props) => props.theme.modal.sizes.mobile};
  ${(props) => props.theme.motion};
  padding: ${(props) => (props.size === "lg" ? "0" : "24px")};
  max-width: ${(props) =>
    props.size === "xsm"
      ? "500px"
      : props.size === "sm"
      ? "515px"
      : props.size === "md"
      ? "624px"
      : "95vw"};
  max-height: ${(props) =>
    props.size === "xsm"
      ? "240px"
      : props.size === "sm"
      ? "300px"
      : props.size === "md"
      ? "auto"
      : "100vh"};
  min-height: ${(props) =>
    props.size === "xsm"
      ? "180px"
      : props.size === "sm"
      ? "280px"
      : props.size === "md"
      ? "450px"
      : "auto"};

  .tmp-button-icon {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  @media (max-width: 768px) {
    transform: translateY(100%);
    ${(props) =>
      props.isOpened &&
      css`
        transform: translateY(0);
      `}
  }
  @media (min-width: 768px) {
    margin: 0 auto;
    height: auto;
    ${(props) => props.theme.modal.sizes.tablet};
  }
`;

export const ModalContent = styled.div`
  position: relative;
  height: 100%;
  overflow: auto;
`;

interface PropsModalFooter {
  size: string;
}

export const ModalFooter = styled.div<PropsModalFooter>`
  ${(props) => props.theme.footer.sizes.mobile}
  max-height: ${(props) =>
    props.size === "xsm"
      ? "82px"
      : props.size === "sm"
      ? "90px"
      : props.size === "md"
      ? "auto"
      : "auto"};
  padding: ${(props) => (props.size === "lg" ? "0" : "24px")};
  > button {
    display: block;
    width: 100%;
  }
  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    ${(props) => props.theme.footer.sizes.tablet};
    margin: -${(props) => props.theme.modal.sizes.mobile.padding};
    > button {
      display: flex;
      width: auto;
    }
  }
`;
